import React, { useEffect, useState } from "react";
import {
  FaShieldAlt,
  FaHandshake,
  FaHome,
  FaCheckCircle,
  FaUsers,
  FaBuilding,
  FaRupeeSign,
  FaFileAlt,
  FaBolt
} from "react-icons/fa";
import OwnerCard from "./Owner";
import "./AboutUs.css";

const AboutUs = () => {
  const [properties, setProperties] = useState(0);
  const [customers, setCustomers] = useState(0);
  const [years, setYears] = useState(0);

  useEffect(() => {
    const interval1 = setInterval(() => setProperties(p => p < 100 ? p + 1 : 100), 20);
    const interval2 = setInterval(() => setCustomers(c => c < 80 ? c + 1 : 80), 25);
    const interval3 = setInterval(() => setYears(y => y < 5 ? y + 1 : 5), 200);
    return () => { clearInterval(interval1); clearInterval(interval2); clearInterval(interval3); };
  }, []);

  const coreValues = [
    { icon: <FaHandshake />, title: "Integrity", desc: "Ethical, transparent and honest dealings always." },
    { icon: <FaShieldAlt />, title: "Trust", desc: "Building long-term relationships beyond transactions." },
    { icon: <FaCheckCircle />, title: "Legal Excellence", desc: "100% legally verified properties." },
    { icon: <FaUsers />, title: "Client-Centric Approach", desc: "Personalized service for every client." },
    { icon: <FaBolt />, title: "Efficiency", desc: "Quick & seamless property transactions." },
    { icon: <FaHome />, title: "Quality Listings", desc: "Carefully curated premium properties." }
  ];

  const usp = [
    { icon: <FaShieldAlt />, text: "Verified Properties" },
    { icon: <FaRupeeSign />, text: "Transparent Pricing" },
    { icon: <FaFileAlt />, text: "Complete Documentation Support" },
    { icon: <FaBolt />, text: "Quick Transactions" },
    { icon: <FaHandshake />, text: "Strong Negotiation Expertise" },
    { icon: <FaUsers />, text: "Dedicated Relationship Manager" },
    { icon: <FaHome />, text: "Premium & Luxury Listings" },
    { icon: <FaBuilding />, text: "Residential & Commercial Expertise" }
  ];

  return (
    <div className="about-container" id="about-section">
      {/* Hero / Intro */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>About Sai Bhavana Realty</h1>
          <p>
            We specialize in verified plots, lands, apartments, and houses with complete documentation support.
            Our mission is to make buying and selling safe, transparent, and hassle-free.
          </p>
        </div>
      </section>

      <section className="counters-section">

        <div className="counters">
          <div className="counter">
            <FaBuilding className="counter-icon" />
            <h3>{properties}+</h3>
            <p>Properties Sold</p>
          </div>
          <div className="counter">
            <FaUsers className="counter-icon" />
            <h3>{customers}+</h3>
            <p>Satisfied Customers</p>
          </div>
          <div className="counter">
            <FaShieldAlt className="counter-icon" />
            <h3>{years}+</h3>
            <p>Years of Experience</p>
          </div>
        </div>
      </section>

      <section className="mission-section">
        <div className="mission-container">
          <div className="mission-box">
            <h2>Our Mission</h2>
            <p>
              To redefine real estate with integrity, transparency, and exceptional service,
              ensuring every client experiences confidence and security in their investment.
            </p>
          </div>

          <div className="vision-box">
            <h2>Our Vision</h2>
            <p>
              To become the most trusted and premium real estate brand,
              delivering value-driven properties and long-term relationships.
            </p>
          </div>
        </div>
      </section>

      {/* Core Values Timeline */}
      <section className="core-values-section">
        <h2 className="section-title">Our Core Values</h2>

        <div className="core-values-grid">
          {coreValues.map((val, idx) => (
            <div key={idx} className="core-card">
              <div className="core-icon">
                {val.icon}
              </div>

              <h3>{val.title}</h3>
              <p>{val.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="promise-section">
        <h2 className="section-title light">Our Promise</h2>
        <p className="promise-text">
          At Sai Bhavana Realty, we promise complete transparency,
          verified properties, and dedicated support from inquiry to registration.
          Your trust is our greatest asset.
        </p>
      </section>

      {/* Why Choose Us / Horizontal Scroll */}
      <section className="usp-section">
        <h2 className="section-title light">Why Choose Us</h2>

        <div className="usp-icons-container">
          {usp.map((item, idx) => (
            <div key={idx} className="usp-icon-box">
              <div className="usp-main-icon">
                {item.icon}
              </div>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </section>


      {/* Owner Section */}
      <section className="owner-section">
        <h2 className="section-title">Meet the Owner</h2>
        <OwnerCard />
      </section>
    </div>
  );
};

export default AboutUs;